import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
      <path
        d="m35.23,6C17.17,6.58,2.58,21.17,2,39.23h33.23V6Zm-15.34,31.1h-2.09c-4.24,0-7.79-3.35-7.88-7.58-.06-2.92.78-5.78,2.49-8.29.96-1.41,2.2-2.63,3.62-3.57,2.67-1.78,5.83-2.72,9.03-2.71,3.27,0,5.91,2.69,5.91,5.96v5.12c0,6.12-4.96,11.08-11.08,11.08Z"
        fill={colourFill}
      />
      <path
        d="m24.39,17.24c-2.44,0-4.84.64-6.95,1.85-2.52,1.44-4.41,3.75-5.32,6.49-.84,2.52-.81,5.24.12,7.86.33.93,1.24,1.53,2.23,1.53h9.93c2.07,0,3.74-1.68,3.74-3.74v-12.41c0-.87-.71-1.58-1.58-1.58h-2.16Zm1.62,10.64h-2.32c-.44,1.23-1.61,2.13-2.99,2.13-.49,0-.95-.12-1.37-.32l-2.14,2.14-1.51-1.51,2.14-2.14c-.2-.41-.32-.88-.32-1.37,0-1.39.89-2.56,2.13-2.99v-2.32h2.13v2.32c.9.32,1.61,1.03,1.93,1.93h2.32v2.13Z"
        fill={colourFill}
      />
      <path
        d="m18.25,58.24c.55,0,1.1-.23,1.49-.62l.95-.94.95.94c.39.39.94.62,1.5.62.81,0,1.53-.45,1.89-1.17.79-1.58,1.21-3.35,1.21-5.12,0-1.47-1.11-2.58-2.48-2.58-.38,0-.76.09-1.11.26l-1.96.98-1.96-.98c-.34-.17-.73-.26-1.11-.26-1.37,0-2.48,1.11-2.48,2.48,0,1.87.42,3.64,1.21,5.22.36.72,1.09,1.17,1.89,1.17Z"
        fill={colourFill}
      />
      <path
        d="m25.09,47.64c.43-.35.76-.81.95-1.32h-.77c-1.03,0-1.96.48-2.57,1.23.35-.08.71-.12,1.07-.12.46,0,.9.09,1.32.21Z"
        fill={colourFill}
      />
      <path
        d="m43.97,26.11c0,2.44,1.99,4.43,4.43,4.43s4.43-1.99,4.43-4.43c0-1.85-2.45-5.63-4.43-8.2-1.98,2.57-4.43,6.35-4.43,8.2Z"
        fill={colourFill}
      />
      <path d="m21.81,27.21c0,1.48-2.22,1.48-2.22,0s2.22-1.48,2.22,0" fill={colourFill} />
      <path
        d="m37.36,8.56v26.41h26.41c-1.53-13.81-12.6-24.88-26.41-26.41Zm11.05,24.19c-3.67,0-6.65-2.98-6.65-6.65s5.2-9.97,5.8-10.68l.85-1.02.85,1.02c.6.71,5.8,7.06,5.8,10.68s-2.98,6.65-6.65,6.65Z"
        fill={colourFill}
      />
      <path
        d="m50.03,47.03c-.63-.63-1.47-.98-2.37-.98s-1.69.35-2.3.93l3.83,3.82-1.57,1.57-3.51-3.51-1.68,2.94,2.32,2.32-1.57,1.57-1.89-1.89-3.88,6.8c-.06.09-.08.2-.08.32,0,.47.57.79.96.56l12.87-7.35c1.04-.6,1.69-1.71,1.69-2.91,0-.88-.36-1.75-.98-2.37l-1.82-1.82Z"
        fill={colourFill}
      />
      <path
        d="m37.36,37.1v4.26h-4.26v27.64c17.34-.55,31.35-14.56,31.9-31.9h-27.64Zm19.03,12.06h-1.73c.21.59.34,1.21.34,1.85,0,1.99-1.07,3.85-2.8,4.83l-12.87,7.35c-.43.25-.92.38-1.42.38-1.58,0-2.86-1.28-2.86-2.86,0-.5.13-.99.38-1.42l7.35-12.87c.99-1.73,2.84-2.8,4.83-2.8.92,0,1.8.25,2.59.67l2.28-3.8c.36-.6.93-1.08,1.62-1.23,1.65-.37,3.11.87,3.11,2.46v.8c0,.22-.03.44-.08.65l.11.04c1.06.35,1.91,1.21,2.12,2.3.38,1.94-1.1,3.65-2.98,3.65h0Z"
        fill={colourFill}
      />
      <path
        d="m55.09,42.73v-.8c0-.17-.14-.31-.31-.31-.11,0-.21.06-.26.15l-2.12,3.53,2.24-1.68c.28-.21.44-.54.44-.89h0Z"
        fill={colourFill}
      />
      <path
        d="m56.7,45.42l-.7-.23s-.04.05-.07.07l-2.36,1.77h2.87c.45,0,.82-.37.82-.82,0-.35-.23-.67-.56-.78h0Z"
        fill={colourFill}
      />
      <path
        d="m30.97,67.77v-26.41H4.57c1.53,13.81,12.6,24.88,26.41,26.41Zm-13.38-20.96c.7,0,1.4.15,2.03.43v-3.76h2.13v1.22c.92-.77,2.08-1.22,3.32-1.22h3.77v1.11c0,1.34-.54,2.61-1.44,3.58.89.85,1.44,2.03,1.44,3.32,0,2.21-.52,4.33-1.51,6.22-.51.98-1.36,1.76-2.41,2.11-1.47.5-2.98.29-4.15-.48-1.06.7-2.38.93-3.72.61s-2.36-1.27-2.96-2.48c-.91-1.83-1.38-3.86-1.38-5.88,0-2.69,2.19-4.79,4.88-4.79h0Z"
        fill={colourFill}
      />
    </svg>
  );
};

export default ServiceIcon;
